export const RESET_CONTRACT_STATE = "CONTRACT-REVIEW:RESET_STATE";
export const START_CLAUSE_ACTION = "CONTRACT-REVIEW::START_CLAUSE_ACTION";
export const CLAUSE_ACTION = "CONTRACT-REVIEW::CLAUSE_ACTION";
export const TOGGLE_COLLAPSE_CARD_PANEL =
  "CONTRACT-REVIEW::TOGGLE_COLLAPSE_CARD_PANEL";
export const SELECT_CLAUSE = "CONTRACT-REVIEW::SELECT_CLAUSE";
export const DESELECT_CLAUSE = "CONTRACT-REVIEW::DESELECT_CLAUSE";
export const SET_CLAUSE_FILTER = "CONTRACT-REVIEW::SET_CLAUSE_FILTER";
